import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/LESS/vsp-uikit.less';
import './styles/LESS/style.less';
import './styles/LESS/shared.less';
import './styles/LESS/v2/index.less';
import './styles/easybox.min.css';
import './styles/angular-block-ui.min.css';
import './scripts/vendor/datetimepicker/angularjs-datetime-picker.css';
import './scripts/vendor/angucomplete/angucomplete.css';

import 'bootstrap/dist/js/bootstrap';
import 'jquery/dist/jquery';
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-cookies';
import 'angular-messages';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular-http-auth/src/http-auth-interceptor';
import 'lodash';
import 'angular-google-maps/dist/angular-google-maps';
import 'angular-ui-bootstrap/ui-bootstrap-tpls';
import 're-tree';
import 'ng-device-detector';
import 'angularjs-geolocation/src/geolocation';
import 'oclazyload/dist/ocLazyLoad';
import 'angular-google-analytics/dist/angular-google-analytics.min';
import 'angular-block-ui/dist/angular-block-ui';
import 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-2012-2022';
import 'angular-crumble/crumble';
import 'ng-file-upload';
import 'ngstorage/ngStorage';
import 'videogular';
import 'angular-chart.js/dist/angular-chart';
import 'chart.js/dist/Chart.min.js';

import '/scripts/app';
import '/scripts/controllers';
import '/scripts/directives';
import '/scripts/services';
import '/scripts/providers';
import '/scripts/filters';
import '/scripts/config';
import '/scripts/vendor';
